<script setup>
import { ref, watch, getCurrentInstance } from 'vue';
import DashboardActivityStreamItem from './DashboardActivityStreamItem';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const items = ref([]);
const userId = ref(0);

// --- Methods ---

/**
 * These methods are passed to children to track the "previous" userId
 * while iterating, allowing the UI to only show the avatar for the
 * first item in a group by the same user.
 */
const setUserId = (id) => {
    userId.value = id;
};

const getUserId = () => {
    return userId.value;
};

const fetchActivity = async () => {
    try {
        // Fetch the last 10 activity IDs
        const response = await store.dispatch('request/get', {
            url: 'api/component/activity/id',
            params: {
                createdBy: { gt: 0 }, // Items must be assigned to users.
                sort: '-id',
                limit: 10
            }
        });

        const ids = response.data.values;

        if (ids && ids.length > 0) {
            // Preload the full item data for those IDs
            items.value = await store.dispatch('itemData/preload', {
                tableName: 'activity',
                ids
            });
        }
    } catch (error) {
        console.error("Failed to load activity stream:", error);
    }
};

// --- Watchers / Lifecycle ---

// Replaces asyncComputed: triggers on component load
watch(() => true, fetchActivity, { immediate: true });
</script>

<template>
    <div class="card dashboard-panel-activity-stream">
        <div class="card-header">
            Activity stream
        </div>

        <div class="card-body pt-0">
            <DashboardActivityStreamItem
                v-for="item in items"
                :key="item.id"
                :get-user-id="getUserId"
                :item="item"
                :set-user-id="setUserId"
            />
        </div>
    </div>
</template>

<style scoped>
.card-body {
    height: 405px;
    overflow: scroll;
}
</style>